import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    IJourneyItem, UpgradeHelper, AdminToolPanelHelper, AdminToolHelper, AdminToolListData, IAdminToolPanel, JESettingsListData
} from '../../../helpers';
import { PAGING_ITEM_AMOUNT, PANEL_VALUE_JESETTINGS_LIST } from '../../../constants';
import { ROLLBACK_LIST_REFRESH_WARNING, PANEL_VALUE_RESULT_LIST, SPINNER_LOADING_MESSAGE } from '../../../constants';
import { Button, Checkbox, Spinner, SpinnerType, ButtonType, Toggle } from 'office-ui-fabric-react';
import types from '../../../store/types';
import { PanelHeader } from '../panelheader';
import { SearchFilter } from '../searchfilter';
import { ListPaging } from './listpaging';
import { JourneyEngineSettingsHelper } from '../../../helpers/journeyenginesettingshelper';
import store from '../../../store/store';
interface IProps {
    adminToolState: any;
    showStatus: boolean;
    enableRemoveButtons: boolean;
    panelName: string;
    toggleSidebar: () => void;
    updateServerOnly: (jesettingsId: string, serverOnly: number) => void;
}
export class JESettingsList extends React.Component<IProps, any> {
    componentDidMount() {
        AdminToolPanelHelper.SetUpPanelState(this.props.adminToolState, this.props.panelName, true, true, true);
        let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
        let resultList: AdminToolListData[] = (AdminToolPanelHelper.GetPanelValueFromState(panel, PANEL_VALUE_RESULT_LIST) as AdminToolListData[]);
        if (!resultList || resultList.length == 0) {
            AdminToolHelper.getAdminToolList(this.props.panelName, true).then(() => {
                AdminToolPanelHelper.SetPanelIsLoading(this.props.panelName, false);
            })

            // Fetch list of je settings
            JourneyEngineSettingsHelper.getJESettingsList(this.props.panelName).then(() => {
            })
        }
    }

    removeAllButtonClick() {
        AdminToolHelper.ClearProcessList();
    }

    viewItemButtonClick(journey: JESettingsListData) {
        AdminToolHelper.SetJESettingsToSidebar(journey);
    }

    onClickButton() {
        var isJESettingsList: boolean = true;
        AdminToolHelper.getAdminToolList(this.props.panelName, isJESettingsList).then(() => {
            AdminToolPanelHelper.SetPanelIsLoading(this.props.panelName, false);
            AdminToolHelper.ClearProcessList();
        });
    }

    onSelectOption(isChecked: boolean, data: AdminToolListData) {
        let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
        AdminToolPanelHelper.ClearPanelErrorMessages(panel);
        if (data.journeyIds) {
            if (isChecked) {
                let arrayIds = [];
                let journeyItemList: IJourneyItem[] = [];

                let NoJourneysExistInRollbackList: any = data.journeyIds.every(a => (this.props.adminToolState.processList[this.props.adminToolState.tab].filter(d => d.journeyId == a.journeyId).length == 0));
                if (!NoJourneysExistInRollbackList) {
                    AdminToolPanelHelper.AddErrorMessagesToState(panel, "You must rollback this upgrade (" + data.runid + ") separately because this upgrade contains a journey that is already in the rollback list.")
                    AdminToolPanelHelper.SetPanelIsLoading(this.props.panelName, true);
                }
                else {
                    data.journeyIds.forEach((value) => {
                        arrayIds.push(value.journeyId);
                        journeyItemList.push({ journeyId: value.journeyId, version: value.fromVersion, journeyName: "loading...", upgradeStatus: "", upgradeId: data.runid });
                    });
                }
                AdminToolHelper.AddToProcessListWithTitles(arrayIds, journeyItemList, this.props.panelName)
            }
            else {
                data.journeyIds.forEach((value) => {
                    AdminToolHelper.RemoveToProcessList(value.journeyId);
                });
            }
        }
    }

    searchFilters(jesettingsListData: JESettingsListData[], panel: IAdminToolPanel) {
        if (jesettingsListData) {
            let search: string = AdminToolPanelHelper.GetSearchFilters(panel);
            if (search) {
                jesettingsListData = (jesettingsListData.filter(value => value.nameField && value.nameField.indexOf(search) > -1 ||
                    value.keyField && value.keyField.indexOf(search) > -1 ||
                    value.valueField && value.valueField.indexOf(search) > -1 ||
                    value.serverOnly && value.serverOnly.toString() === search ||
                    value.journeyEngineSettingsId && value.journeyEngineSettingsId.indexOf(search) > -1 ||
                    value.description && value.description.indexOf(search) > -1
                    // ||
                    // value.startTime && AdminToolPanelHelper.FormatDate(new Date(value.startTime)).indexOf(search) > -1))
                ));
            }
        }
        return jesettingsListData;
    }
    render() {

        let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
        let resultList: JESettingsListData[] = (AdminToolPanelHelper.GetPanelValueFromState(panel, PANEL_VALUE_JESETTINGS_LIST) as JESettingsListData[]);
        let errorsList: string[] = AdminToolPanelHelper.GetErrorMessagesFromState(panel);
        let isLoading = AdminToolPanelHelper.IsLoading(panel);
        let errors: any = errorsList && errorsList.map(result => <p>{result}</p>);

        resultList = this.searchFilters(resultList, panel);
        var mapResults = resultList && resultList.map((JESettingsListData: JESettingsListData, index: any) => {
            return (<tr key={index}>
                <td title={JESettingsListData.nameField}>{JESettingsListData.nameField}</td>
                <td title={JESettingsListData.keyField}>{JESettingsListData.keyField}</td>
                <td title={JESettingsListData.valueField}>{JESettingsListData.valueField}</td>
                <td>{JESettingsListData.serverOnly === 0 ?
                    <Toggle checked={false} onText="Yes" offText="No" onChanged={(val) => {
                        this.props.updateServerOnly(JESettingsListData.journeyEngineSettingsId, val ? 1 : 0)
                    }} />
                    :
                    <Toggle checked={true} onText="Yes" offText="No" onChanged={(val) => {
                        this.props.updateServerOnly(JESettingsListData.journeyEngineSettingsId, val ? 1 : 0)
                    }} />
                }</td>
                {this.props.enableRemoveButtons && <td><Button icon="View"
                    buttonType={ButtonType.icon}
                    onClick={() => { this.viewItemButtonClick(JESettingsListData); }}
                    title='Quick View' /></td>}
            </tr>);
        });
        let displayed: boolean = AdminToolPanelHelper.IsPanelDisplayed(panel);

        let pagingNumber: number = AdminToolPanelHelper.GetPaging(panel);
        if (mapResults && mapResults.length)
            mapResults = mapResults.slice(pagingNumber, pagingNumber + PAGING_ITEM_AMOUNT);

        return (<div className={"admintool-panelcontainer"}>
            <PanelHeader panelName={this.props.panelName} panelTitle={"Journey Engine Settings List"} enableToggle={true} isEnabled={true} adminToolState={this.props.adminToolState} />
            <div className="panel-content rollback-journeys" style={!displayed ? { display: 'none' } : {}}>

                <Button onClick={() => {
                    this.onClickButton();

                }}>Refresh JE Settings List</Button>

                <Button
                    className="jesettings-button"
                    disabled={isLoading}
                    icon="Add"
                    buttonType={ButtonType.primary}
                    onClick={() => {
                        this.props.toggleSidebar();
                    }}>
                    Add New Record
                </Button>

                <div className="jesettings-table">
                    {isLoading && <div><Spinner className="loading-bulk" type={SpinnerType.normal} label={SPINNER_LOADING_MESSAGE} /></div>}

                    <SearchFilter disable={isLoading} adminToolState={this.props.adminToolState} panelName={this.props.panelName} />
                    <table>
                        <tbody>
                            <tr key="columns">
                                <td>Name</td>
                                <td>Key</td>
                                <td>Value</td>
                                <td>Server Only</td>
                                <td></td>
                            </tr>
                            {
                                mapResults
                            }
                        </tbody>

                    </table>
                    {
                        (mapResults && mapResults.length) ?
                            null
                            :
                            'No data'
                    }

                </div>
                <br />

                <ListPaging disable={isLoading} panelName={this.props.panelName} adminToolState={this.props.adminToolState} pagingNumber={pagingNumber} pagingMax={pagingNumber + PAGING_ITEM_AMOUNT} list={resultList} />
                <br />
                {errors && errors.length > 0 && <div className="alert alert-danger" role="alert">
                    {errors}
                </div>}
            </div>
        </div>)
    }
}


// WEBPACK FOOTER //
// ./source/ts/components/admintool/panels/jesettingslist.tsx